import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import BalancePageHeader from '../BalancePageHeader';
import PageDocumentDetails from '../../../PageDocumentDetails';
import { cardActions } from '../../../../state/actions/card.actions';
import { companyActions } from '../../../../state/actions/company.actions';

const TransactionsPageHeaderWrapper = ({
  getCardsSummaries,
  getEmployees,
  getTags,
}) => {
  const [t] = useTranslation(['main', 'transactions']);

  const {breadcrumbs, pageTitle} = useMemo(() => {
    const title = t('pageTitles.transactionsList');
    return {
      breadcrumbs: [{title}],
      pageTitle: title
    }
  }, [t]);

  useEffect(() => {
    getCardsSummaries();
    getEmployees();
    getTags();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <PageDocumentDetails title={pageTitle} />
      <BalancePageHeader breadcrumbs={breadcrumbs} />
    </>
  );
}

const mapDispatchToProps = {
  getCardsSummaries: cardActions.getCardsSummaries,
  getEmployees: companyActions.getEmployees,
  getTags: companyActions.getTags,
}

export default connect(null, mapDispatchToProps)(TransactionsPageHeaderWrapper);
